import localizationDefinitions from '~~/i18n/localizationDefinitions';
import { getPrefix } from '~~/helpers/routes/prefixes';
import { DEFAULT_REDIRECTION_CODE } from '~~/constants/seo';
import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from '#imports';
import type { LocationQueryRaw, LocationQueryValueRaw } from 'vue-router';

const isLocationQueryValueRaw = (value: unknown): value is LocationQueryValueRaw | LocationQueryValueRaw[] => {

  if (value == null) {

    return true;

  }

  if (Array.isArray(value)) {

    return value.every((entry) => isLocationQueryValueRaw(entry));

  }

  return typeof value === 'string' || typeof value === 'number';

};

const normalizeQuery = (query: Record<string, unknown>): LocationQueryRaw => {

  return Object.entries(query).reduce<LocationQueryRaw>((acc, [key, value]) => {

    if (isLocationQueryValueRaw(value)) {

      acc[key] = value;

    }

    return acc;

  }, {});

};

export default defineNuxtRouteMiddleware((to /* , from */) => {

  const currentPrefix = to?.path ? getPrefix(to.path) : undefined;

  const nuxtApp = useNuxtApp();
  const i18n = (nuxtApp?.$i18n ?? nuxtApp?.$vueI18n) as any;
  const countryCode: string | undefined =
    i18n?.localeProperties?.value?.country ?? i18n?.localeProperties?.country;

  if (!countryCode) {

    return;

  }
  
  const acceptedLanguages: string[] =
    localizationDefinitions.getByCountryCode(countryCode)?.getLanguages() || [];

  if (
    currentPrefix &&
    (!acceptedLanguages.includes(currentPrefix) || acceptedLanguages[0] === currentPrefix)
  ) {

    const safeQuery = normalizeQuery(to.query as unknown as Record<string, unknown>);

    return navigateTo({ path: '/', query: safeQuery }, { replace: true, redirectCode: DEFAULT_REDIRECTION_CODE });

  }

  return;

});
